import { render, staticRenderFns } from "./NavBarV.vue?vue&type=template&id=18f21f7e&scoped=true"
import script from "./NavBarV.vue?vue&type=script&lang=js"
export * from "./NavBarV.vue?vue&type=script&lang=js"
import style0 from "./NavBarV.vue?vue&type=style&index=0&id=18f21f7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f21f7e",
  null
  
)

export default component.exports